<template>
  <div class="decode">
    <form action="">
      <div>url加密处理</div>
      <textarea
        id="enter"
        :value="address"
        @input="address = $event.target.value"
      >
      </textarea>

      <br />
      <input id="sure" type="button" @click="sure()" value="跳转" />
      <input type="reset" class="channel" value="清空" />
      <input
        type="reset"
        class="channel"
        @click="switchAccount"
        value="切换地址"
      />
      <input
        type="reset"
        class="channel"
        @click="switchAgency"
        value="代理游客"
      />
    </form>
  </div>
</template>

<script>
// import globalUtils from "../../../../utils";
import { JSEncrypt } from "encryptlong";

const firstUrl = `https://192.168.1.3:8080/login?DoMain=http://localhost:8002&cusType=1&enterScene=0
&mainColor=blue&productId=zz&rechargeCode=&userId=47&userName=aaawhz2222&vipLevel=0`;

const secondUrl = `https://192.168.1.3:8080/login?DoMain=http://localhost:8002&cusType=1&enterScene=0
&mainColor=blue&productId=zz&rechargeCode=&userId=45&userName=aaawhz2&vipLevel=0`;

const mlUrl = `https://192.168.1.2:8080/login?DoMain=http://m-www.miletest.com/&cusType=1
&enterScene=0&mainColor=blue&productId=ml&rechargeCode=&userId=12379&userName=aaawhz1&vipLevel=0`;

// const agencyUrl = `https://192.168.1.3:8080/login?cusType=3&enterScene=5&mainColor=yellow&productId=ml`;

const agencyLoginUrl = `https://192.168.1.3:8080/login?cusType=4&enterScene=5&mainColor=yellow&productId=ml&userId=1471877&userName=eagleelite&vipLevel=0`;

export default {
  name: "decode",
  data() {
    return {
      address: mlUrl
    };
  },
  methods: {
    replaceAllStr(f, e) {
      var reg = new RegExp(f, "g");
      return this.replace(reg, e);
    },

    urlsafeEncode(e) {
      return e
        .replaceAllStr("\\+", "-")
        .replaceAllStr("/", "_")
        .replaceAllStr("=", "");
    },
    switchAccount() {
      if (this.address === firstUrl) {
        this.address = secondUrl;
      } else {
        this.address = firstUrl;
      }
      console.log(this.address);
    },
    switchAgency() {
      // if (this.address === agencyLoginUrl) {
      //   this.address = agencyUrl;
      // } else {
      //   this.address = agencyLoginUrl;
      // }
      this.address = agencyLoginUrl;
    },
    sure() {
      var message = this.address;
      console.log(message, "hahh");
      if (message.indexOf("?") < 0) {
        window.open(message, "_blank");
      } else {
        var array = message.split("?");
        var publicKey =
          "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDbWe+gtTWgQYB3IHxY0GUUDEq0otgy0Cl/MNGGXBud4f8Mf86Spj8oWIuAMGaSm730OGzEaR5vxO5niG+stETin78ZWZUT/xIPC9Zr3k5GhQk4rx6yYVfSenENUlb8f2WEzA5ne+K/sYD8rU13dKUtX7z8IVKoDeU2E3tHIDwMKQIDAQAB";
        var encrypt = new JSEncrypt();
        encrypt.setPublicKey(publicKey);
        var encryptStr = encrypt.encryptLong(array[1]);
        var urlsafe = this.urlsafeEncode(encryptStr);
        window.open(array[0] + "?configKey=" + urlsafe, "_blank");
      }
    }
  }
};
</script>

<style scoped>
form {
  width: 80%;
  margin: 50px auto;
}
#enter {
  width: 100%;
  height: 100px;
  border: 1px solid #666;
  padding: 10px;
}
#sure {
  padding: 5px 15px;
  color: #fff;
  background: #1162ff;
  border: none;
  border-radius: 5px;
  margin: 10px 10px 0 0;
}
.channel {
  margin-right: 20px;
  background: #fff;
  padding: 5px 15px;
  color: #1162ff;
  cursor: pointer;
  border: 1px solid #1162ff;
  border-radius: 5px;
}
</style>
